import { BehaviorSubject } from "rxjs";
import LoadingState from "./LoadingState";

const authPromiseStore: {
  isRefreshing: boolean;
  authPromise?: Promise<any>;
  statusSubject: BehaviorSubject<LoadingState>;
} = {
  isRefreshing: false,
  authPromise: undefined,
  statusSubject: new BehaviorSubject<LoadingState>(LoadingState.NO_DATA),
};

export default authPromiseStore;
